import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';

export default function ResponsiveChipSkeleton() {
	return (
		<Stack display="flex" flexWrap="wrap" direction="row" gap={1}>
			{Array.from(new Array(4)).map((_, index) => (
				<Skeleton
					data-testid="skeletonLoadingChips"
					// eslint-disable-next-line react/no-array-index-key
					key={index}
					sx={{ borderRadius: 4 }}
					variant="rectangular"
					width={80}
					height={32}
				/>
			))}
		</Stack>
	);
}
